'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../node_modules/tslib/tslib.es6.js');
var React = require('react');
var Header = require('./Header/Header.js');
var handlePhoneNumber = require('../../utils/handlePhoneNumber.js');
var Login = require('./Login.js');
require('../../styles/index.scss.js');
require('../../../node_modules/react-responsive-modal/styles.css.js');
var Button = require('../Button/Button.js');
require('../../../node_modules/classnames/index.js');
require('../ButtonGroup/ButtonGroup.scss.js');
require('../Badge/Badge.scss.js');
require('../Label/Label.scss.js');
require('../Checkbox/Checkbox.scss.js');
require('../Icon/Icon.scss.js');
require('../Button/helper.scss.js');
require('../Switch/Switch.scss.js');
require('../Radio/Radio.scss.js');
var Input = require('../Input/Input.js');
require('../Loader/Loader.scss.js');
require('../Footer/Footer.scss.js');
require('../Navbar/Navbar.js');
require('../Navbar/MobileNavigation/styles.scss.js');
require('../../../node_modules/pure-react-carousel/dist/index.es.js');
require('../Carousel/Carousel.scss.js');
require('../../../node_modules/pure-react-carousel/dist/react-carousel.es.css.js');
require('../Pagination/Pagination.scss.js');
require('../Modal/Modal.scss.js');
require('../DropDown/DropDown.scss.js');
require('../Accordion/AccordionGroup.js');
require('../Accordion/AccordionIcon.scss.js');
require('../Accordion/Accordion.scss.js');
require('../Stepper/Stepper.scss.js');
require('../Tabs/Tabs.scss.js');
require('../BottomNavigation/FooterNavigation/Tools/Tools.scss.js');
require('../BottomNavigation/FooterNavigation/Insurance/Insurance.scss.js');
require('../BottomNavigation/FooterNavigation/Account/Account.scss.js');
require('../BottomNavigation/FooterNavigation/Explore/Explore.scss.js');
require('../BottomNavigation/FooterNavigation/FooterNavigation.scss.js');
require('../../utils/hooks/canUseWebp.js');
require('../BottomNavigation/BottomNavigation.scss.js');
require('../ViewMore/ViewMore.scss.js');
require('../MFELogin/index.js');
require('../Swiper/index.js');
require('../Alert/Alert.scss.js');
require('../Loader/LifepalLoader.js');
require('../SEOAccordion/SEOAccordion.scss.js');
require('../Skeleton/index.js');
require('../LifepalProvider/LifepalProvider.js');
require('react-dom');
require('../../../node_modules/react-responsive-modal/node_modules/classnames/index.js');
require('../../../node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js');
require('../ResponsiveModal/style.scss.js');
require('../Card/Card.js');
var index = require('./LockedUserMessage/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var LoginForm = function (props) {
    var previous = props.previous, isModal = props.isModal;
    var _a = React.useState(false), send = _a[0], setSend = _a[1];
    var _b = React.useState(''), phoneNum = _b[0], setPhoneNum = _b[1];
    var _c = Login.useLoginContext(), backToPrev = _c.backToPrev, emailIconSrc = _c.emailIconSrc, googleIconSrc = _c.googleIconSrc, errorMessage = _c.errorMessage; _c.phoneNumber; var sendOtp = _c.sendOtp, loginWithGoogle = _c.loginWithGoogle; _c.closeModalClick; var buttonNextId = _c.buttonNextId, googleButtonLoading = _c.googleButtonLoading, nextButtonLoading = _c.nextButtonLoading, goToRegister = _c.goToRegister, isUserLocked = _c.isUserLocked;
    var getOtp = function () { return tslib_es6.__awaiter(void 0, void 0, void 0, function () {
        var phoneValid, error_1;
        return tslib_es6.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, sendOtp(handlePhoneNumber.handlePhoneNumber(phoneNum))];
                case 1:
                    phoneValid = _a.sent();
                    setSend(true);
                    if (phoneValid) {
                        backToPrev('otp');
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.log(error_1);
                    return [2 /*return*/];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    React.useEffect(function () {
        if (send) {
            if (!errorMessage.phoneNumber && phoneNum !== '') {
                backToPrev('otp');
            }
            else {
                setSend(false);
            }
        }
    }, [send]);
    return (React__default['default'].createElement(React__default['default'].Fragment, null,
        !isModal && React__default['default'].createElement(Header, { showBackBtn: false, isModal: isModal, onBackBtnClick: function () { return backToPrev(previous); } }),
        React__default['default'].createElement("div", { className: isModal ? 'form--modal' : 'form' },
            isModal && React__default['default'].createElement(Header, { showBackBtn: false, isModal: isModal, onBackBtnClick: function () { return backToPrev(previous); } }),
            isUserLocked && React__default['default'].createElement(index, null),
            React__default['default'].createElement(Input.Input, { id: 'input-phone-number', name: 'input-phone-number', type: 'tel', inputMode: 'tel', placeholder: 'Nomor Handphone', size: 'lg', className: "" + ((errorMessage && errorMessage.phoneNumber) ? 'input-error' : 'bottom-18p'), onChange: function (e) { return setPhoneNum(e.target.value); }, disabled: nextButtonLoading || googleButtonLoading }),
            errorMessage && errorMessage.phoneNumber &&
                React__default['default'].createElement("p", { className: 'text-error bottom-18p top-5p' }, errorMessage.phoneNumber),
            React__default['default'].createElement(Button.Button, { id: buttonNextId || 'next-to-otp', isLoading: nextButtonLoading || googleButtonLoading, className: "\n            action-button bottom-16p " + ((nextButtonLoading || googleButtonLoading) ? 'button-action-disabled' : '') + "\n          ", onClick: function () { getOtp().then(function () { setSend(true); }); } }, "Selanjutnya"),
            React__default['default'].createElement("div", { className: 'or bottom-16p' },
                React__default['default'].createElement("div", { className: 'divider' }),
                React__default['default'].createElement("span", null, "atau masuk dengan"),
                React__default['default'].createElement("div", { className: 'divider' })),
            React__default['default'].createElement(Button.Button, { id: 'login-by-email', className: "\n            redirect-button bottom-16p " + ((nextButtonLoading || googleButtonLoading) ? 'button-disabled' : '') + "\n          ", isLoading: nextButtonLoading || googleButtonLoading, onClick: function () { return backToPrev('login-email'); } },
                React__default['default'].createElement("div", { className: 'right-5p d-flex' },
                    React__default['default'].createElement("img", { src: emailIconSrc, alt: 'mail' })),
                "Masuk Menggunakan Email"),
            React__default['default'].createElement(Button.Button, { id: 'login-by-google', className: "redirect-button " + ((googleButtonLoading || nextButtonLoading) ? 'button-disabled' : ''), isLoading: googleButtonLoading || nextButtonLoading, onClick: loginWithGoogle },
                React__default['default'].createElement("div", { className: 'right-5p d-flex' },
                    React__default['default'].createElement("img", { src: googleIconSrc, alt: 'google' })),
                "Masuk Menggunakan Gmail"),
            React__default['default'].createElement("div", { className: 'regis__text' },
                "Belum memiliki akun ? ",
                React__default['default'].createElement("a", { onClick: goToRegister, className: 'go_to_regis' }, "Daftar Sekarang"),
                " "))));
};

exports.LoginForm = LoginForm;
//# sourceMappingURL=loginForm.js.map
